/**
 * @ngdoc Controller
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .controller('ShareController', ShareController);

    /* @ngInject */
    function ShareController($scope, installation, close, ApiService, $timeout, locale, vrmNotificationsService, vrmNotificationType) {
        var saveDelay = 500;
        $scope.timer = null;
        $scope.siteShare = {};
        $scope.url = "";
        $scope.iframe = "";


        locale.ready('share').then(function () {
            ApiService.call('/installations/' + installation.idSite + '/retrieve-share', {}, 'GET').then(function (response) {
                storeShare(response);
                createMissingEmbed();

                $scope.$watch('siteShare', function (newVal, oldVal) {
                    if (!angular.equals(oldVal, newVal) || $scope.doSendMail) {
                        // Only save every saveDelay milliseconds and if there is a change
                        $timeout.cancel($scope.timer);
                        $scope.timer = $timeout(function () {
                            // Copy object so no new watch is triggered
                            var data = angular.copy($scope.siteShare);

                            // Make sure that we send an email only once
                            data.sendMail = $scope.doSendMail;
                            $scope.doSendMail = false;

                            // Save share
                            ApiService.call('/installations/' + installation.idSite + '/share', data, 'POST').then(function (response) {
                                $scope.url = response.data.url;
                                vrmNotificationsService.add({
                                    type: vrmNotificationType.SUCCESS,
                                    message: data.sendMail ? locale.getString('share.share_sent') : locale.getString('share.share_saved')
                                });
                            });

                            // Save embed
                            ApiService.call('/installations/' + installation.idSite + '/embed', data, 'POST').then(function (response) {
                                $scope.iframe = response.data.iframe;
                            });
                        }, saveDelay);
                    }
                }, true);

                $scope.$watch('passwordEnabled', function (passwordEnabled) {
                    // Disable password if switch is toggled of
                    if (!passwordEnabled && $scope.siteShare.password) $scope.siteShare.password = false;
                });
            });

            ApiService.call('/installations/' + installation.idSite + '/retrieve-embed', {}, 'GET').then(function (response) {
                storeEmbed(response);
                createMissingEmbed();
            });
        });

        $scope.passwordModel = {
            password: null
        };

        $scope.savePassword = function () {
            $scope.siteShare.password = $scope.passwordModel.password;
            $scope.passwordEnabled = true;
        };

        $scope.copyUrl = function () {
            copy('private-share-url');
        }

        $scope.copyIframe = function () {
            copy('private-embed-iframe');
        }

        function copy(elementId) {
            var el = document.getElementById(elementId);
            if (document.body.createTextRange) {
                // IE
                var textRange = document.body.createTextRange();
                textRange.moveToElementText(el);
                textRange.select();
                textRange.execCommand("Copy");
            } else if (window.getSelection && document.createRange) {
                // non-IE
                var editable = el.contentEditable; // Record contentEditable status of element
                var readOnly = el.readOnly; // Record readOnly status of element
                el.contentEditable = true; // iOS will only select text on non-form elements if contentEditable = true;
                el.readOnly = false; // iOS will not select in a read only form element
                var range = document.createRange();
                range.selectNodeContents(el);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range); // Does not work for Firefox if a textarea or input
                if (el.nodeName === "TEXTAREA" || el.nodeName === "INPUT")
                    el.select(); // Firefox will only select a form element with select()
                if (el.setSelectionRange && navigator.userAgent.match(/ipad|ipod|iphone/i))
                    el.setSelectionRange(0, 999999); // iOS only selects "form" elements with SelectionRange
                el.contentEditable = editable; // Restore previous contentEditable status
                el.readOnly = readOnly; // Restore previous readOnly status
                if (document.queryCommandSupported("copy")) {
                    document.execCommand('copy');
                }
            }
        }

        $scope.doSendMail = false;
        $scope.mailAddress = null;
        $scope.sendMail = function () {
            $scope.doSendMail = true;
            $scope.siteShare.email = $scope.mailAddress;
        };

        function storeShare(response) {
            if (response.data.siteShare == null) { response.data.siteShare = false; }
            $scope.siteShare = response.data.siteShare ? response.data.siteShare : {};
            $scope.siteShare.enabled = response.data.siteShare ? true : false;
            $scope.passwordEnabled = response.data.siteShare && response.data.siteShare.password ? true : false;
            $scope.url = response.data.siteShare.url;
        }

        function storeEmbed(response) {
            if (response.data.embed == null) {response.data.embed = false;}
            $scope.embed = response.data.embed;
            $scope.iframe = response.data.embed.iframe;
        }

        function createMissingEmbed() {
            if ($scope.siteShare.enabled && $scope.embed === false) {
                ApiService.call('/installations/' + installation.idSite + '/embed', angular.copy($scope.siteShare), 'POST').then(function (response) {
                    $scope.iframe = response.data.iframe;
                });
            }
        }

        return {
            close: close
        };
    }

})();

